import React, { useEffect } from 'react';
import { Container, Form, Header, Dropdown, Icon, Breadcrumb, Button, Grid, Placeholder, Checkbox, Message, TextArea } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { useHistory, useLocation } from 'react-router';
import { useRSASpecialistMeetingForm } from './useRSASpecialistMeetingForm';

import _ from 'lodash';

export function RSASpecialistMeetingForm() {

    let [values, masterData,coordinatorMaster,
        errors, touched, isLoading, isSubmitting, isValid,
        submitSuccess, errorMessage, shouldDisplayOtherField, otherFieldText,
        registerRef, handleChange, handleBlur, handleSubmit] = useRSASpecialistMeetingForm();

    const history = useHistory();

    useEffect(() => {
        window.setTimeout(()=>{
            window.scrollTo(0,0);
        },100);
    
    }, []);

    return <Container className='providers-container'>
        <Header as='h1' style={{ marginTop: '2.0rem', marginBottom: '0.5rem' }}>Meet with an RSA Employment Coordinator</Header>
        <hr style={{ marginBottom: '1.0rem' }} />
        <Breadcrumb style={{ marginBottom: '1.0rem' }}>
            <Breadcrumb.Section link><Link to='/'>Home</Link></Breadcrumb.Section>
            <Breadcrumb.Divider />
            <Breadcrumb.Section active>Schedule a meeting with an RSA Employment Coordinator</Breadcrumb.Section>
        </Breadcrumb>
        <Grid style={submitSuccess ? { margin: 0 } : {}}>
            {
                !(masterData && masterData.length >= 1) &&
                <Grid.Column>
                    <Placeholder fluid>
                        <Placeholder.Paragraph>
                            <Placeholder.Line />
                            <Placeholder.Line />
                            <Placeholder.Line />
                            <Placeholder.Line />
                            <Placeholder.Line />
                            <Placeholder.Line />
                            <Placeholder.Line />
                            <Placeholder.Line />
                            <Placeholder.Line />
                            <Placeholder.Line />
                            <Placeholder.Line />
                            <Placeholder.Line />
                            <Placeholder.Line />
                            <Placeholder.Line />
                            <Placeholder.Line />
                        </Placeholder.Paragraph>
                    </Placeholder>
                </Grid.Column>
            }
            {
                !submitSuccess && (masterData && masterData.length >= 1) &&
                <Grid.Column  mobile={16} tablet={16} computer={12}>
                    <Message
                        color='blue'
                        icon='info circle'
                        header='Schedule A Meeting'
                        content="Please complete the form below to meet with an RSA Employment Coordinator."
                    />
                    <Form loading={isSubmitting}>
                        <Form.Input className={!(!errors.firstName || !touched.firstName) ? 'mb-0' : ''}
                            required
                            aria-required="true"
                            fluid
                            label='First Name'
                            onChange={(event, data) => {
                                handleChange(data.value, 'firstName');
                            }}
                            onBlur={
                                () => { handleBlur('firstName') }
                            }
                            error={!(!errors.firstName || !touched.firstName) ? true : false}
                        />
                        {
                            !(!errors.firstName || !touched.firstName) &&
                            <div className='error-message'><Icon name='warning sign' color='orange' /> {errors.firstName}</div>
                        }
                        <Form.Input className={!(!errors.lastName || !touched.lastName) ? 'mb-0' : ''}
                            required
                            aria-required="true"
                            fluid
                            label='Last Name'
                            onChange={(event, data) => {
                                handleChange(data.value, 'lastName');
                            }}
                            onBlur={
                                () => { handleBlur('lastName') }
                            }
                            error={!(!errors.lastName || !touched.lastName) ? true : false}
                        />
                        {
                            !(!errors.lastName || !touched.lastName) &&
                            <div className='error-message'><Icon name='warning sign' color='orange' /> {errors.lastName}</div>
                        }
                        <Form.Input className={!(!errors.phoneNumber || !touched.phoneNumber) ? 'mb-0' : ''}

                            fluid
                            label='Phone Number'
                            value = {values.phoneNumber}
                            onChange={(event, data) => {
                                handleChange(data.value, 'phoneNumber');
                            }}
                            onBlur={
                                () => { handleBlur('phoneNumber') }
                            }
                            error={!(!errors.phoneNumber || !touched.phoneNumber) ? true : false}
                        />
                        {
                            !(!errors.phoneNumber || !touched.phoneNumber) &&
                            <div className='error-message'><Icon name='warning sign' color='orange' /> {errors.phoneNumber}</div>
                        }
                        <Form.Input className={!(!errors.email || !touched.email) ? 'mb-0' : ''}
                            required
                            aria-required="true"
                            fluid
                            label='Email Address'
                            onChange={(event, data) => {
                                handleChange(data.value, 'email');
                            }}
                            onBlur={
                                () => { handleBlur('email') }
                            }
                            error={!(!errors.email || !touched.email) ? true : false}
                        />
                        {
                            !(!errors.email || !touched.email) &&
                            <div className='error-message'><Icon name='warning sign' color='orange' /> {errors.email}</div>
                        }
                        <Form.Input className={!(!errors.confirmEmail || !touched.confirmEmail) ? 'mb-0' : ''}
                            required
                            aria-required="true"
                            fluid
                            label='Confirm Email Address'
                            onChange={(event, data) => {
                                handleChange(data.value, 'confirmEmail');
                            }}
                            onBlur={
                                () => { handleBlur('confirmEmail') }
                            }
                            error={!(!errors.confirmEmail || !touched.confirmEmail) ? true : false}
                        />
                        {
                            !(!errors.confirmEmail || !touched.confirmEmail) &&
                            <div className='error-message'><Icon name='warning sign' color='orange' /> {errors.confirmEmail}</div>
                        }
                        {
                            coordinatorMaster && coordinatorMaster.length > 0 &&
                            <Form.Field required
                                error={!(!errors.coordinatorId || !touched.coordinatorId) ? true : false}
                                className={!(!errors.coordinatorId || !touched.coordinatorId) ? 'mb-0' : ''}>
                                <label>Employment Coordinator</label>
                                <Dropdown
                                    placeholder=' - Select an Employment Coordinator - '
                                    fluid
                                    closeOnChange={true}
                                    clearable
                                    selection
                                    selectOnBlur={false}
                                    value={values.coordinatorId}
                                    options={coordinatorMaster}
                                    onChange={(event, data) => {
                                        let newValue = (data as { value: any }).value;
                                        handleChange(newValue, 'coordinatorId');
                                    }}
                                    onClose={
                                        () => { handleBlur('coordinatorId') }
                                    }
                                    error={!(!errors.coordinatorId || !touched.coordinatorId) ? true : false}
                                />
                                {
                                    !(!errors.coordinatorId || !touched.coordinatorId) &&
                                    <div className='error-message'><Icon name='warning sign' color='orange' /> {errors.coordinatorId}</div>
                                }
                            </Form.Field>
                        }
                        <div className={'field required ' + (!(!errors.helpTopicIds || !touched.helpTopicIds) ? 'error' : '')}>
                            <label>Help Topic</label>
                            {
                                masterData && masterData.map((topicItem, index) => {
                                    return (
                                        <Form.Field key={index}>
                                            <Checkbox label={topicItem.displayName}
                                                checked={values.helpTopicIds.includes(topicItem.employmentHelpTopicId)}
                                                onChange={(e, { checked }) => {
                                                    let newValue = _.cloneDeep(values.helpTopicIds);
                                                    if (!checked) {
                                                        let targetIndex = newValue.indexOf(topicItem.employmentHelpTopicId);
                                                        newValue.splice(targetIndex, 1);
                                                    } else {
                                                        newValue.push(topicItem.employmentHelpTopicId);
                                                    }
                                                    handleChange(newValue, 'helpTopicIds');
                                                }}
                                            />
                                        </Form.Field>
                                    );
                                })
                            }
                            {
                                shouldDisplayOtherField &&
                                <>
                                    <Form.Input className={!(!errors.otherAssistance || !touched.otherAssistance) ? 'mb-0' : ''}
                                        aria-required="true"
                                        fluid
                                        label={otherFieldText}
                                        onChange={(event, data) => {
                                            handleChange(data.value, 'otherAssistance');
                                        }}
                                        onBlur={
                                            () => { handleBlur('otherAssistance') }
                                        }
                                        error={!(!errors.otherAssistance || !touched.otherAssistance) ? true : false}
                                    />
                                    {
                                        !(!errors.otherAssistance || !touched.otherAssistance) &&
                                        <div className='error-message'><Icon name='warning sign' color='orange' /> {errors.otherAssistance}</div>
                                    }
                                </>
                            }
                            {
                                !(!errors.helpTopicIds || !touched.helpTopicIds) &&
                                <div className='error-message'><Icon name='warning sign' color='orange' /> {errors.helpTopicIds}</div>
                            }

                        </div>
                        <Form.Field className={!(!errors.preferedDateTime || !touched.preferedDateTime) ? 'mb-0 error' : ''}
                            required
                            aria-required="true"
                        >
                            <label>Preferred Date and Time</label>
                            <div><Icon name='info circle' color='blue'></Icon> Please provide a few options.</div>
                            <TextArea

                                required
                                aria-required="true"
                                onChange={(event, data) => {
                                    handleChange(data.value, 'preferedDateTime');
                                }}
                                onBlur={
                                    () => { handleBlur('preferedDateTime') }
                                }
                                error={!(!errors.preferedDateTime || !touched.preferedDateTime) ? true : false}
                            />
                        </Form.Field>
                        {
                            !(!errors.preferedDateTime || !touched.preferedDateTime) &&
                            <div className='error-message'><Icon name='warning sign' color='orange' /> {errors.preferedDateTime}</div>
                        }
                        <Form.TextArea className={!(!errors.comments || !touched.comments) ? 'mb-0' : ''}
                            required
                            aria-required="true"
                            label='Comments'
                            onChange={(event, data) => {
                                handleChange(data.value, 'comments');
                            }}
                            onBlur={
                                () => { handleBlur('comments') }
                            }
                            error={!(!errors.comments || !touched.comments) ? true : false}
                        />
                        {
                            !(!errors.comments || !touched.comments) &&
                            <div className='error-message'><Icon name='warning sign' color='orange' /> {errors.comments}</div>
                        }


                        <Button type='button' loading={isSubmitting} primary onClick={handleSubmit}>Submit</Button>
                        <Button type='button' onClick={() => { history.goBack() }}>Cancel</Button>
                    </Form>
                </Grid.Column>
            }
            {
                submitSuccess &&
                <Message icon positive>
                    <Icon name='check circle outline' color='green' />
                    <Message.Content>
                        <Message.Header>Success</Message.Header>
                        <div>Thank you. An RSA Employment Coordinator will contact the job seeker to confirm the appointment.</div>
                        <div style={{ marginTop: '0.5rem' }}>
                            <Link to='/'>Back to home page</Link>
                        </div>
                    </Message.Content>
                </Message>
            }

        </Grid>

    </Container>
}